import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import "../../App.css";
import CalendarCheck from "../../assets/images/icons/CalendarCheck.svg";
import CompanyStoreIcon from "../../assets/images/icons/CompanyStoreIcon.svg";
import DeviceMobileCamera from "../../assets/images/icons/DeviceMobileCamera.svg";
import EnvelopeSimpleOpen from "../../assets/images/icons/EnvelopeSimpleOpen.svg";
import Info from "../../assets/images/icons/Info.svg";
import MapPin from "../../assets/images/icons/MapPin.svg";
import User from "../../assets/images/icons/User.svg";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import { CookieService } from "../../Service/CookieService";
import Logo from "../Logo/Logo";
import ProfileBar from "../Static/Profile/ProfileBar";
import { RootState } from "../store";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import BackToSuperAdminIcon from "../../assets/images/icons/BackToSuperAdminIcon.svg";
import Constant from "../../Constant";

const UserHeader = () => {
  const cookies = new Cookies();
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const currentPath = location.pathname;
  const { id } = useParams<{ id: string }>();
  const params = id === undefined ? CommonService.getCompanyId() : id;
  const [companyDetails, setCompanyDetails] = useState<any>({});
  const [formattedDate, setFormattedDate] = useState<string>("");
  const productName = useSelector((state: RootState) => state.cart.productName);
  const loginAsUser = localStorage.getItem("loginAsUser");
  
  const logout = () => {
    CookieService.removeAuthToken();
    history.push("/login");
  };

  const fetchUserRole = () => {
      const cookies = new Cookies();
      const role = cookies.get("userRole");
      setUserRole(role);
  };

  const fetchCurrentPath = () => {
      // Update the activeTab state based on the current pathname
      if (currentPath === "/master/dashboard") {
        setActiveTab("dashboard");
      } else if (currentPath === "/user/my-warehouse") {
        setActiveTab("dashboard");
      } else if (currentPath === "/inventories") {
        setActiveTab("inventories");
      } else if (currentPath === "/my-inventory") {
        setActiveTab("my-inventory");
      } else if (currentPath === "/inventory-sell-requests") {
        setActiveTab("inventory-sell-requests");
      } else if (currentPath === "/login-history") {
        setActiveTab("login-history");
      } else if (currentPath.includes("/view-csv")) {
        setActiveTab("view-csv");
      } else if (currentPath.includes("/view-sell_request")) {
        setActiveTab("view-sell-request");
      } else if (currentPath.includes("/my-cart")) {
        setActiveTab("my-cart");
      } else {
        setActiveTab("");
      }
  };

  const redirectToLoginPage = () => {
    history.push('/login');
  }

  const redirectToSignupPage = () => {
    history.push('/signup');
  }

  useEffect(() => {
    if (CommonService.isUserLoggedIn()) {
      fetchCurrentPath();
    }
  }, [location.pathname]);

  useEffect(() => {
    if(CommonService.isUserLoggedIn()) {
      fetchUserRole();
      fetchCompanyById();
    }
  }, [params]);

  function route(route: string) {
    history.push(route);
  }

  function historyBack() {
    if (
      history.action === "PUSH" ||
      history.action === "REPLACE" ||
      (location.state && (location.state as any).fromInternal)
    ) {
      history.goBack();
      return;
    }
    console.log(currentPath);
    const previousRoute = document.referrer || ""; // Get the referrer URL
    if (previousRoute.endsWith("master/dashboard")) 
      history.goBack();
    else if(previousRoute.endsWith("user/my-warehouse"))
      history.goBack();
    else{
    switch (true) {
      case currentPath === "/user/empty-cart":
      case currentPath.startsWith("/user/empty-cart"):
        history.push(`/user/inventories`);
        break;
  
      case currentPath.startsWith("/user/view-sell-request/"):
        history.push(`/user/inventory-sell-requests`);
        break;
  
      case currentPath === "/user/inventory-sell-requests":
        history.push(`/user/my-warehouse`);
        break;
  
      case currentPath.startsWith("/user/order-detail"):
        history.push(`/user/my-warehouse/active-order`);
        break;
  
      case currentPath === "/user/my-warehouse/active-order":
        history.push(`/user/my-warehouse`);
        break;
  
      case currentPath.startsWith("/user/view-offer-request/"):
        history.push(`/user/my-warehouse/offer-request`);
        break;
  
      case currentPath.startsWith("/user/view-sample-request/"):
        history.push(`/user/my-warehouse/sample-request`);
        break;
  
      case currentPath.startsWith("/user/my-warehouse/user-list/"):
        history.push(`/user/my-warehouse`);
        break;
  
      case currentPath.startsWith("/user/my-warehouse/offer-request"):
      case currentPath.startsWith("/user/my-warehouse/sample-request"):
        history.push(`/user/my-warehouse`);
        break;
  
      default:
        console.log("executed history back");
        history.goBack();
        break;
    }
  }
  }  

  const fetchCompanyById = async () => {
    const response: any = await Service.fetchCompanyById(params);
    setCompanyDetails(response.data);
    setFormattedDate(
      format(new Date(response.data.createdDate), "MMMM dd, yyyy")
    );
  };

  // Exit impersonation and restore original admin session
  const backToSuperAdmin = async () => {
      try {
        // Get the saved admin token and info
        const adminToken = localStorage.getItem("adminTokenBackup");
        const adminUser = localStorage.getItem("adminUserBackup");
  
        if (!adminToken || !adminUser) {
          console.error("No admin backup found, cannot exit impersonation");
          return;
        }
  
        const adminData = JSON.parse(adminUser);
  
        // Restore cookies
        CookieService.setAuthToken("authToken", adminToken);
        CookieService.setAuthToken("userRole", adminData.role || Constant.Role.SUPER_ADMIN);
        CookieService.setAuthToken("userId", adminData.userId || "");
        CookieService.setAuthToken("userName", adminData.userName || "");
        CookieService.setAuthToken("companyId", adminData.companyId || "");
        CookieService.setAuthToken("companyName", adminData.companyName || "");
  
        // Clean up impersonation storage
        localStorage.removeItem("impersonatedUser");
        localStorage.removeItem("adminTokenBackup");
        localStorage.removeItem("adminUserBackup");
        localStorage.removeItem("loginAsUser");
        localStorage.removeItem("updateUserName");
        localStorage.removeItem("profile");

        // Redirect to admin dashboard
        history.push("/master/dashboard");
  
      } catch (error) {
        console.error("Failed to exit impersonation", error);
      }
    };

  return (
    <header className="wd__header wd__header--user">
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/user/inventories">
            <Logo size={"200px"} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
           {CommonService.isUserLoggedIn() ? (
            <ul
              className="navbar-nav ms-auto mb-2 mb-lg-0"
              style={{ cursor: "pointer" }}
            >
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span onClick={() => route("/user/inventories")}>
                    Marketplace
                  </span>
                  <ExpandMoreRoundedIcon />
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => route("/user/wanted-to-buy")}
                    >
                      Wanted To Buy
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/user/my-warehouse")}
                  role="button"
                  aria-expanded="false"
                >
                  Dashboard
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/user/messages")}
                  role="button"
                  aria-expanded="false"
                >
                  Inbox
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/user/customer-service")}
                >
                  Customer Service
                </a>
              </li> 
              {CommonService.isUser() && loginAsUser && (
              <li>
                <a
                  className="d-inline-flex justify-content-between align-items-center back_to_admin"
                  href="#"
                  style={{ paddingLeft: 15 }}
                  onClick={backToSuperAdmin}
                >
                  <img src={BackToSuperAdminIcon} alt="back to super admin" />
                  Back to Super Admin
                </a>
              </li>
              )}

              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/user/view-contract")}
                >
                 Contracts
                </a>
              </li>  */}

            </ul>
           ) : (
              <div className=" d-flex justify-content-end gap-2 flex-wrap w-100">
                <button
                  type="button"
                  className="btn secondary-btn px-5"
                  onClick={redirectToLoginPage} // redirect to login page
                >
                  Login
                </button>
                <button
                  type="button"
                  className="btn primary-btn px-5"
                  onClick={redirectToSignupPage} // redirect to signup page
                >
                  Signup
                </button>
              </div>
           )} 
          </div>
        </div>
      </nav>
      <div className={ `header__banner bg-body-tertiary ${(currentPath !== "/user/my-warehouse" && currentPath !== "/user/view-as-owner" && currentPath !== "/user/view-as-buyer") ? "" : "header__for-user"}`}>
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
          <div>            
              <div
                className="back__button me-3 d-flex align-items-center"
              >
                {(currentPath !== "/user/inventories" && currentPath !== "/user/my-warehouse" && currentPath !== "/user/view-as-owner" && currentPath !== "/user/view-as-buyer") && (currentPath !== "/user/wanted-to-buy") && (currentPath !== '/user/customer-service') && (currentPath !== "/user/messages") && (
                <IconButton
                  aria-label="ArrowBackIcon"
                  sx={{
                    backgroundColor: "#FFF",
                    mb: 1,
                    "&:hover": { backgroundColor: "#FFF" },
                  }}
                  onClick={() => historyBack()}
                >
                  <ArrowBackIcon sx={{ color: "#1C1B1F" }}/>
                </IconButton>)}

                {(currentPath.startsWith("/user/user-detail")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    User Profile
                  </h3>
                )}

                {(currentPath.startsWith("/user/my-profile")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    My Profile
                  </h3>
                )}

                {(currentPath.startsWith("/user/inventories")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Marketplace
                  </h3>
                )}

                {(currentPath.startsWith("/user/wanted-to-buy-product-details")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    {productName}
                  </h3>
                )}

                {(currentPath.startsWith("/user/wanted-to-buy")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Wanted To Buy
                  </h3>
                )}

                {currentPath.startsWith("/user/customer-service") &&
                  (<h3 className="ms-2 fw-bold text-white">
                   Customer Service
                  </h3>
                )}

                {currentPath.startsWith("/user/add-customer-service-request") &&
                  (<h3 className="ms-2 fw-bold text-white">
                    {/* Create New Request */}
                    Customer Service
                  </h3>
                )}

                {currentPath.startsWith("/user/view-customer-service-request") &&
                  (<h3 className="ms-2 fw-bold text-white">
                    Customer Service Request Details
                  </h3>
                )}

                {currentPath.startsWith("/user/edit-customer-service-request") &&
                  (<h3 className="ms-2 fw-bold text-white">
                    Update Customer Service Request
                  </h3>
                )}

                {currentPath === "/user/barrel-market-value" && (
                  <h3 className="ms-2 fw-bold text-white">
                    Insurance Values by Container Lot
                  </h3>
                )}

                {currentPath.startsWith("/user/barrel-market-value-chart-view") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Insurance Values by Container Lot Graphical View
                  </h3>
                )}
 
                {(currentPath.startsWith("/user/messages")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Inbox
                  </h3>
                )}

                {(currentPath === "/user/my-warehouse/inventory") && (
                  <h3 className="ms-2 fw-bold text-white">
                    My Virtual Warehouse
                  </h3>
                )}

                {(currentPath === "/user/my-warehouse/marketplace-listings") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Marketplace Listings
                  </h3>
                )}

                {(currentPath === "/user/my-warehouse/ownership-transfer-listings") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Ownership Transfer
                  </h3>
                )}

                {(currentPath.startsWith("/user/view-inventory-listing-details")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Inventory Details
                  </h3>
                )}

                {(currentPath.startsWith("/user/view-sold-inventory-listing-details")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Sold Inventory Details
                  </h3>
                )}

                {(currentPath.startsWith("/user/my-warehouse/available-for-sell")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Listed for Sale
                  </h3>
                )}

                {(currentPath.startsWith("/user/my-warehouse/not-available-for-sell")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Unlisted for Sale
                  </h3>
                )}

                {(currentPath.startsWith("/user/view-edit-sell-request-history")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Sell Request Edit History
                  </h3>
                )}

                {(currentPath.startsWith("/user/product-details")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    {productName}
                  </h3>
                )}

                {(currentPath.startsWith("/user/my-cart")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Cart Details
                  </h3>
                )}

                {(currentPath.startsWith("/user/my-warehouse/user-list") || currentPath.startsWith("/user/user-list")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Users
                  </h3>
                )}

                {(currentPath.startsWith("/user/add-user")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Add User
                  </h3>
                )}

                {(currentPath.startsWith("/user/add-owner")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Add New owner
                  </h3>
                )}

                {(currentPath.startsWith("/user/barrel-owners")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Manage Owners
                  </h3>
                )}

                {(currentPath.startsWith("/user/update-owner")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Update Owner Details
                  </h3>
                )}

                {(currentPath.startsWith("/user/view-csv") ||
                  currentPath.startsWith("/user/view-sell-request/")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Sell Request Details
                  </h3>
                )}

                {(currentPath.startsWith("/user/market-value-history")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Current Market Value History
                  </h3>
                )}

                {(currentPath == "/user/view-contract") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Contracts
                  </h3>
                )}

                {(currentPath.startsWith("/user/view-contract/")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Contract Details
                  </h3>
                )}

                {(currentPath.startsWith("/user/contract-pricing-details/")) && (
                  <h3 className="ms-2 fw-bold text-white">
                     Contract Pricing Details
                  </h3>
                )}


                {/* {(currentPath == "/user/inventory-sell-requests") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Sell Requests
                  </h3>
                )} */}

                {(currentPath == "/user/active-order" || currentPath.startsWith("/user/view-as-buyer/order-detail") ||
                  currentPath.startsWith("/user/view-as-owner/order-detail") || currentPath.startsWith("/user/order-detail")) && (
                  <h3 className="ms-2 fw-bold text-white">Order Request Details</h3>
                )}

                {(currentPath == "/user/my-warehouse/active-order") && (
                  <h3 className="ms-2 fw-bold text-white">Order Requests</h3>
                )}

                {(currentPath == "/user/sample-request" ||
                  currentPath.startsWith("/user/view-sample-request")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Sample Request Details
                  </h3>
                )}

                {(currentPath == "/user/my-warehouse/sample-request") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Sample Requests
                  </h3>
                )}
                
                {(currentPath == "/user/offer-request" ||
                  currentPath.startsWith("/user/view-offer-request")) && (
                  <h3 className="ms-2 fw-bold text-white">Offer Request Details</h3>
                )}
                {(currentPath == "/user/my-warehouse/offer-request") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Offer Requests
                  </h3>
                )}

                {(currentPath == "/user/wish-list") && (
                  <h3 className="ms-2 fw-bold text-white">
                    Wishlist
                  </h3>
                )}

                {(currentPath == "/user/my-requests" ||
                  currentPath.startsWith("/my-requests")) && (
                  <h3 className="ms-2 fw-bold text-white">My Requests</h3>
                )}

                {(currentPath == "/user/my-warehouse" ||
                  currentPath == "/user/view-as-owner" || currentPath == "/user/view-as-buyer") && (
                    <h3 className="ms-2 fw-bold text-white">Dashboard</h3>
                )}

                 {(currentPath.startsWith("/user/my-warehouse/service-requests")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Service Requests
                  </h3>
                )}

                {(currentPath.startsWith("/user/edit-barrel")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Edit Container Details
                  </h3>
                )}
                {(currentPath.startsWith("/user/proof-history")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Proofing History
                  </h3>
                )}
                {(currentPath.startsWith("/user/valuation-history")) && (
                  <h3 className="ms-2 fw-bold text-white">
                    Valuation History
                  </h3>
                )}


                {/* {(currentPath == "/user/my-warehouse" ||
                  currentPath == "/user/view-as-owner" || currentPath == "/user/view-as-buyer") && (
                    <>
                  <h4 className="dashboard__user--title my-2 px-2 lh-base text-white">
                    {companyDetails?.companyName}
                  </h4>
                  <div className="dashboard__user--companyInfo my-2 px-2">
                  <Dropdown>
                    <Dropdown.Toggle variant="info">
                      <img src={Info} alt="Info" />
                    </Dropdown.Toggle>
      
                    <Dropdown.Menu>
                      <ListGroup>
                        <ListGroup.Item>
                          <div className="company-details d-flex align-items-center">
                            <img src={CompanyStoreIcon} alt="CompanyStoreIcon" />
                            <span className="company-name ms-2">
                             {companyDetails?.companyName && companyDetails.companyName.trim() !== "" ? companyDetails.companyName : "-"}
                            </span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <div className="icon">
                            <img src={User} alt="User" />
                          </div>
                          <div className="info d-flex flex-column mx-3">
                            <span className="sub-title">Contact Person</span>
                            <span className="detail">{companyDetails?.contactPerson && companyDetails.contactPerson.trim() !== "" ? companyDetails.contactPerson : "-"}</span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <div className="icon">
                            <img src={DeviceMobileCamera} alt="DeviceMobileCamera" />
                          </div>
                          <div className="info d-flex flex-column mx-3">
                            <span className="sub-title">Contact Number</span>
                            <span className="detail">{companyDetails?.contactNumber && companyDetails.contactNumber.trim() !== "" ? companyDetails.contactNumber : "-"}</span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <div className="icon">
                            <img src={EnvelopeSimpleOpen} alt="EnvelopeSimpleOpen" />
                          </div>
                          <div className="info d-flex flex-column mx-3">
                            <span className="sub-title">Email</span>
                            <span className="detail">{companyDetails?.email && companyDetails.email.trim() !== "" ? companyDetails.email : "-"}</span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <div className="icon">
                            <img src={MapPin} alt="MapPin" />
                          </div>
                          <div className="info d-flex flex-column mx-3">
                            <span className="sub-title">Location</span>
                            <span className="detail">
                            {companyDetails?.city}{companyDetails?.city ?? "-"} {companyDetails?.state}{" "}
                            {companyDetails?.zipcode}
                            </span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <div className="icon">
                            <img src={CalendarCheck} alt="CalendarCheck" />
                          </div>
                          <div className="info d-flex flex-column mx-3">
                            <span className="sub-title">Joining Date</span>
                            <span className="detail">{formattedDate}</span>
                          </div>
                        </ListGroup.Item>
                      </ListGroup>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                </>
                )} */}
              </div>
              {/* {userRole == "ADMIN" && (
                  <div className="header--title">
                    <h1 className="title text-white fs-2 fw-semibold mb-0">
                      My Inventory
                      <i className="bi bi-heart-fill"></i>
                    </h1>
                  </div>
                )} */}
          </div>
          <ProfileBar />
        </div>
      </div>

      {/* <div>
    
                <div className="logout"> 
                    <Button variant="contained" size="small" onClick={logout}>Logout</Button>
                </div>
            </div> */}
    </header>
  );
};

export default UserHeader;
